export const meetingBodyCategoriesCube = {
    category: 'Meeting Bodies',
    description: 'Categories used to classify meeting bodies.',
    label: 'Meeting Body Categories',
    measures: {
        'meeting_body_categories.count': { label: 'Count', type: 'number' },
    },
    dimensions: {
        'meeting_body_categories.description': {
            label: 'Description',
            narrative: true,
            type: 'string',
        },
        'meeting_body_categories.is_archived': { label: 'Is Archived', type: 'boolean' },
        'meeting_body_categories.name': { label: 'Name', type: 'string' },
    },
    timeDimensions: {
        'meeting_body_categories.created_at': { label: 'Created At', type: 'date' },
        'meeting_body_categories.updated_at': { label: 'Updated At', type: 'date' },
    },
};
